import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { Link, useNavigate, useLocation } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { useUser } from "../utils/UserContext";
import { Toaster, toast } from 'react-hot-toast';

function LoginPage() {
  const { user } = useUser();
  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user]);
  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const useremail = queryParams.get("user");
  
    if (useremail) {
      fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_verify: true, useremail: useremail })
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
          } else {
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, [location.search]);

  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState(false);
  const [error1, setError1] = useState(false);
  const [errorValue, setErrorValue] = useState();
  const [errorValue1, setErrorValue1] = useState();
  const navigate = useNavigate();
  function validatePassword (value){
    setPassword(value);
    if (value.length < 8) {
        setError1(true);
        setErrorValue1("Password must be at least 8 characters long.");
    } else {
        setError1(false);
        setErrorValue1("");
    }
  }
  function validateEmail (value){
    setEmail(value);
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        setError(true);
        setErrorValue("Please enter a valid email address");
    } else {
        setError(false);
        setErrorValue("");
    }
  }
  useEffect(() => {
    if(email && password){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [email, password]);

  const handleLogin = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_login: true, email: email, password: password})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else if(data.status === "enroll"){
        localStorage.setItem('user.email', email)
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "enrollment";
        }, 2000);
      }else if(data.status === "xadmin"){
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  } 

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
      <div><Toaster/></div>
      <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
          Back to homepage
        </Link>
      </header>
      <main className="flex-grow-1 d-flex justify-content-center p-3 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 col-xl-4">
              <div className="mb-4">
                <h1 className="fs-4 fw-semibold">Log in to your account</h1>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type="email"
                    className="form-control py-2"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => validateEmail(e.target.value)}
                    required
                  />
                </div>
                {error && (
                  <p className="mb-0 text-danger fs-7 mt-1">{errorValue}</p>
                )}
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control py-2"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => validatePassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-secondary"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ zIndex: 5 }}
                  >
                    {showPassword ? <FontAwesomeIcon icon={faEyeSlash} size={16}/> : <FontAwesomeIcon icon={faEye} size={16}/>}
                  </button>
                </div>
                {error1 && (
                  <p className="mb-0 text-danger fs-7 mt-1">{errorValue1}</p>
                )}
              </div>
              <div className="d-flex flex-column my-4">
                <Link to="/register" className="text-prime fw-bold mb-2 noLink">
                  Don't have an account?
                </Link>
                <Link to="/forgot-password" className="text-prime fw-bold mb-2 noLink">
                  Forgot your password?
                </Link>
              </div>
              <div className={`btn btn-secondary w-100 py-2 fw-bold ${disable?'disabled':null}`} onClick={!disable ? handleLogin : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Log in'}</div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default LoginPage